/**
 * Decisão pura de render do ProtectedRoute. Consentimento continua antes de
 * qualquer tela autenticada; não há mais bifurcação de onboarding por status.
 */
export type ProtectedRender = 'loader-skeleton' | 'none' | 'terms' | 'children';

export function protectedRouteRender(opts: {
  authLoading: boolean;
  hasUser: boolean;
  needsConsent: boolean | null;
}): ProtectedRender {
  if (opts.authLoading) return 'loader-skeleton';
  if (!opts.hasUser) return 'none';
  if (opts.needsConsent === null) return 'loader-skeleton';
  if (opts.needsConsent) return 'terms';
  return 'children';
}
